// import "swiper/css";
// import './HomePage.css';
// import image from './home.webp';
// import SpeedIcon from '@mui/icons-material/Speed';
// import TaskAltIcon from "@mui/icons-material/TaskAlt"

// function HomePage(){
//   return (
//     <div className="HomePage">
//       <div className="image-container">
//         <img src={image} alt="Image 1" className="swiper-image" />
//         <div className="overlay"></div>
//         <label className="overlay-label">
//           確かな技術で
//           <br/>
//           あなたのビジネスを支える、頼れる機械整備
//           <br/>
//           <span className="small-text">Driving food innovation with precision and trust.</span>
//         </label>
//       </div>
//       <div className="sub-contents1">
//         <p>philosophy</p>
//         <label>企業理念</label>
//         <div class="box-container">
//           <div class="box">
//             <SpeedIcon className="icon" />
//             <labal className='box-title'>
//               確かな信頼
//             </labal>
//             <div className="box-contents">
//               <label>長年の経験と確かな技術で、お客様に安心を提供。誠実な対応を心がけ、どんなご要望にも柔軟に対応します。ここにどんどん内容を書いていければいいんだよね</label>
//             </div>
//           </div>
//           <div class="box">
//             <SpeedIcon className="icon" />
//             <labal className='box-title'>
//               迅速な対応力
//             </labal>
//             <div className="box-contents">
//               <label>長年の経験と確かな技術で、お客様に安心を提供。誠実な対応を心がけ、どんなご要望にも柔軟に対応します。ここにどんどん内容を書いていければいいんだよね</label>
//             </div>
//           </div>
//           <div class="box">
//             <TaskAltIcon className="icon" />
//             <labal className='box-title'>
//               高い満足度
//             </labal>
//             <div className="box-contents">
//               <label>長年の経験と確かな技術で、お客様に安心を提供。誠実な対応を心がけ、どんなご要望にも柔軟に対応します。ここにどんどん内容を書いていければいいんだよね</label>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="sub-contents2">
//         <p>philosophy</p>
//         <label>提携企業一覧</label>
//         <div class="box-container2">
//           <div class="box2"></div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HomePage;



import "swiper/css";
import { useRef, useState } from 'react';
import './HomePage.css';
import image from './home.png';
import HandshakeIcon from "@mui/icons-material/Handshake";
import BoltIcon from "@mui/icons-material/Bolt";
import StarsIcon from "@mui/icons-material/Stars";

function HomeVideo({ src }) {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const playVideo = () => {
    videoRef.current?.play();
  };

  return (
    <div className="home-video-frame">
      <video
        ref={videoRef}
        className="home-video"
        controls
        muted
        playsInline
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={() => setIsPlaying(false)}
      >
        <source src={src} type="video/mp4" />
      </video>
      {!isPlaying && (
        <button
          className="home-video-play"
          type="button"
          onClick={playVideo}
          aria-label="動画を再生"
        >
          <span className="home-video-play-icon" />
        </button>
      )}
    </div>
  );
}

function HomePage() {
  return (
    <div className="HomePage">
      <div className="image-container">
        <img src={image} alt="メインイメージ" className="swiper-image" />
        <div className="overlay"></div>
        <div className="hero-panel">
          <h1 className="hero-title">
            確かな技術で
            <br />
            あなたのビジネスを支える
          </h1>
          <p className="hero-body">
            常に技術革新を追求し、お客様の期待を超える製品とサービスを提供することを使命とし、
            社会への貢献を通じて持続可能な未来を創造します。
          </p>
        </div>
      </div>

      <div className="sub-contents1">
        <p>REASON</p>
        <label>選ばれる理由</label>
        <div className="box-container">
          <div className="box">
            <HandshakeIcon sx={{ fontSize: 50, color: '#1f6fb2', mb: 2 }} />
            <label className="box-title">確かな信頼</label>
            <div className="box-contents">
              <label>
                長年にわたり培ってきた経験と確かな技術をもとに、安心してお任せいただけるサービスを提供しています。誠実で丁寧な対応を大切にし、お客様との信頼関係を何より重視しています。
              </label>
            </div>
          </div>

          <div className="box">
            <BoltIcon sx={{ fontSize: 50, color: '#1f6fb2', mb: 2 }} />
            <label className="box-title">迅速な対応力</label>
            <div className="box-contents">
              <label>
                お問い合わせからご相談、施工・対応まで、スピード感を持って柔軟に対応します。急なご要望やお困りごとにも、状況に応じた最適なご提案で迅速にサポートいたします。
              </label>
            </div>
          </div>

          <div className="box">
            <StarsIcon sx={{ fontSize: 50, color: '#1f6fb2', mb: 2 }} />
            <label className="box-title">高い満足度</label>
            <div className="box-contents">
              <label>
                お客様一人ひとりのご要望に寄り添い、品質と仕上がりにこだわった対応を徹底しています。細かな部分まで丁寧に取り組むことで、期待を超える満足をご提供します。
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="home-video-section">
        <p>movie</p>
        <label>動画紹介</label>
        <div className="home-video-list">
          <HomeVideo src="/video/IMG_0606~video.mp4" />
          <HomeVideo src="/video/IMG_0611~video.mp4" />
        </div>
      </div>

      {/* <div className="sub-contents2">
        <p>partners</p>
        <label>提携企業一覧</label>
        <div className="box-container2">
          <div className="box2">企業ロゴなど</div>
        </div>
      </div> */}
    </div>
  );
}

export default HomePage;
